import style from './loader.module.scss';

export function Loader() {
  return (
    <div className={style.loader_container}>
      <div className={style.loader}></div>
    </div>
  );
}
